import { render, staticRenderFns } from "./StptrdSendNew.vue?vue&type=template&id=482ec3f6&scoped=true"
import script from "./StptrdSendNew.vue?vue&type=script&lang=js"
export * from "./StptrdSendNew.vue?vue&type=script&lang=js"
import style0 from "./StptrdSendNew.vue?vue&type=style&index=0&id=482ec3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ec3f6",
  null
  
)

export default component.exports